import { emailRegex, passwordRegex } from "../const/regex";

export const validateFields = (email, password) => {
  if (!emailRegex.test(email.trim())) {
    return { validationSuccess: false, validationMessage: "Please enter a valid email" };
  }
  if (!passwordRegex.test(password.trim())) {
    return { validationSuccess: false, validationMessage: "Please enter a valid password" };
  }
  return { validationSuccess: true, validationMessage: "Fields are valid" };
};